module.exports = __webpack_public_path__ + "static/media/uk.53e9518f.svg";